<div class="properties">
	<div class="inspector-top-bar multi" [hidden]="widgetSelection?.widgets?.length < 2">
		<div class="tab-label">
			{{ widgetSelection?.widgets?.length }} selected widgets
		</div>
		<div class="ie-icon-button no-hover partial-support"
		[class.selection-partial]="visibleWidgets?.length < stageWidgets?.length && visibleWidgets?.length !== 0"
		[class.selection-all]="visibleWidgets?.length === stageWidgets?.length"
		(click)="setWidgetsVisibility(stageWidgets, visibleWidgets?.length !== stageWidgets?.length)">
			<i class="fa" [class.fa-eye]="visibleWidgets?.length !== 0" [class.fa-eye-slash]="visibleWidgets?.length === 0"></i>
		</div>
	</div>
	<div *ngIf="currentTab === 'actions' && !nonStageWidgetsSelected" class="align-distribute" [hidden]="widgetSelection?.widgets?.length < 2">
		<ie-align-distribute></ie-align-distribute>
	</div>
	<div class="inspector-top-bar" [hidden]="currentTab === 'actions' && !selectedWidget">
		<div class="tab-icon ie-icon-display">
			<span *ngIf="currentTab === 'actions'" [innerHTML]="selectedWidget?.type | widgetIcon"></span>
			<span *ngIf="currentTab === 'messages'" class="button-icon">≥</span>
			<i *ngIf="currentTab === 'form'" class="fa fa-wpforms"></i>
		</div>
		<div class="selected-widget" *ngIf="currentTab === 'actions'">
			<div class="tab-label" [title]="selectedWidget?.label || selectedWidget?.type">
				{{ selectedWidget?.label || selectedWidget?.type }}
			</div>
		</div>
		<div class="tab-label" *ngIf="currentTab === 'form'">
			{{ 'FORM_CONFIGURATION' | translate }}
		</div>
		<div class="tab-label" *ngIf="currentTab === 'messages'">
			{{ 'MESSAGE_HANDLERS' | translate }}
		</div>
		<div *ngIf="currentTab === 'actions' && isStageWidget(selectedWidget)" class="ie-icon-button no-hover partial-support" [class.selection-all]="selectedWidget?.visibility === 'visible'" (click)="toggleWidgetVisibility(selectedWidget)">
			<i class="fa" [class.fa-eye]="selectedWidget?.visibility === 'visible'" [class.fa-eye-slash]="selectedWidget?.visibility !== 'visible'"></i>
		</div>
	</div>

	<div *ngIf="currentTab === 'form'">
		<ie-form-config 
			(procedureContextMenu)="onProcedureContextMenu($event.ev, $event.key, $event.index, $event.item)"
			(eventHandlerContextMenu)="onEventHandlerContextMenu($event.ev, $event.key, $event.index, $event.item)">
		</ie-form-config>
	</div>

	<div *ngIf="currentTab === 'actions'" class="field-container" [class.open]="!topBarCollapsed">
		<ie-widget-fields [selectedWidget]="selectedWidget" [selectedWidgetTags]="selectedWidgetTags" [properties]="propertiesOfSelectedWidgets"></ie-widget-fields>
	</div>

	<ng-container *ngIf="singleSelectedWidgetId && currentTab === 'actions'" >
		<!-- accordion off for now -->
		<!-- <mat-accordion> -->
			<ng-container *ngFor="let prop of propertiesOfSelectedWidgets; let i = index; trackBy: eventHandlerTrackBy.bind(this)">
				<event-handler
					*ngIf="propsNotToRender.indexOf( prop.key ) === -1 && eventHandlerNames.indexOf( prop.key ) !== -1"
					#box
					[propertyKey]="prop.key"
					[attr.data-cy]="'event-handler-' + prop.key"
					[stateTrackingUid]="singleSelectedWidgetId + '_eventhandler_' + i"
					[procedures]="(prop.value !== '__...__' && prop.value !== '') ? prop.value : []" 
					(keyup.enter)="onEnterKey($event, prop.key, box.value)"
					(propertyChanged)="propertyChanged($event)"
					(contextmenu)="onEventHandlerContextMenu($event, prop.key, i, prop)"
					(procedureContextMenu)="onProcedureContextMenu($event.ev, $event.key, $event.index, $event.item)">
				</event-handler>
			</ng-container>
		<!-- </mat-accordion> -->
	</ng-container>

	<div class="messages-tab-content" *ngIf="currentTab === 'messages'">
		<div>
			<ng-container *ngFor="let message of messages; let i = index; trackBy: messageTrackBy">
				<event-handler
					#box2
					[propertyKey]="message.name"
					[stateTrackingUid]="message.name + '_eventhandler_' + i"
					[procedures]="message.procedures"
					[titleEditable]="true"
					(keyup.enter)="onMessageEnterKey($event, message.name, box2.value)"
					(propertyKeyChanged)="messageNameChanged($event)"
					(propertyChanged)="messageChanged($event)"
					(contextmenu)="onEventHandlerContextMenu($event, message.name, i, {key: message.name, value: message.procedures, type: 'message'})"
					(procedureContextMenu)="onProcedureContextMenu($event.ev, $event.key, $event.index, $event.item)">
				</event-handler>
				<!-- example delete button (needs design) -->
				<!-- <span (click)="removeMessage(message.name)">
					delete {{ message.name }}
				</span> -->
			</ng-container>
		</div>
		<div class="add-message">
			<ie-form-field [label]="'ADD_MESSAGE_HANDLER' | translate">
				<bb-entity-selector
				[(ngModel)]="newMessageModel"
				(ngModelChange)="onNewMessageSelected($event)"
				[extendable]="true"
				[options]="newMessageOptions"
				name="newMessageSelector"
				theme="dark"
				></bb-entity-selector>
			</ie-form-field>
		</div>
	</div>
</div>
<div class="tab-buttons">
	<div (click)="setTab('actions')" class="tab-button" [class.active]="currentTab === 'actions'">
		<i class="fa fa-hand-sparkles button-icon"></i><br />
		<span class="button-text">{{ 'ACTIONS' | translate }}</span>
	</div>
	<div (click)="setTab('messages')" class="tab-button" [class.active]="currentTab === 'messages'">
		<i class="fa fa-comments button-icon"></i><br />
		<span class="button-text">{{ 'MESSAGES' | translate }}</span>
	</div>
	<div (click)="setTab('form')" class="tab-button" [class.active]="currentTab === 'form'">
		<i class="fa fa-wpforms button-icon"></i><br />
		<span class="button-text">{{ 'FORM' | translate }}</span>
	</div>
</div>
<bb-context-menu [ngStyle]="contextMenuStyle" [themeName]="'dark-theme'" [options]="contextMenuOptions" (optionSelected)="onContextMenuOptionSelected($event)" (clickOutside)="contextMenuHide()"></bb-context-menu>
